import React, { useMemo, useState } from "react";
import { clone, isNil } from "ramda";
import { useIntl } from "react-intl";
import { Autocomplete, Checkbox, FormControl, IconButton, ThemeProvider } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { getMuiTheme } from "../../../../utils/utils";
import palette from "../../../../../config/colorPalette";
import { TextField } from "@mui/material";
import AlertConfig from "../EquipmentInfo/components/alertConfig";

const ThresholdsValues = ({
  thresholdTypes,
  errors,
  setErrors,
  equipment,
  thresholdsValues,
  setThresholdsValues,
  equipmentIndex,
  channelIndex,
  indexSub,
  zoneIndex,
  zones,
  setZones,
  configData,
}) => {
  const intl = useIntl();
  const theme = useMemo(() => getMuiTheme(), []);
  const [openModal, setOpenModal] = useState(false);

  return (
    <ThemeProvider theme={theme}>
      <div style={{ flex: "1", display: "grid" }}>
        <FormControl>
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <Autocomplete
              multiple
              id="measurand_select"
              variant="outlined"
              options={configData.alertConfiguration}
              value={
                !isNil(
                  zones[`equipment${equipmentIndex + 1}`][`channel${channelIndex + 1}`][`sub${indexSub + 1}`][zoneIndex]
                    .alertsConfigurations,
                )
                  ? zones[`equipment${equipmentIndex + 1}`][`channel${channelIndex + 1}`][`sub${indexSub + 1}`][
                      zoneIndex
                    ].alertsConfigurations
                  : []
              }
              sx={{
                width: "16rem", // aumenta el ancho para que quepan más chips
                ".MuiChip-root": {
                  maxWidth: "100%", // permite que los chips no se corten
                },
                ".MuiAutocomplete-tag": {
                  maxWidth: "calc(100% - 16px)", // previene overflow
                },
                marginTop: "4%",
              }}
              disableCloseOnSelect
              onChange={(event, values) => {
                let newZones = clone(zones);
                newZones[`equipment${equipmentIndex + 1}`][`channel${channelIndex + 1}`][`sub${indexSub + 1}`][
                  zoneIndex
                ].alertsConfigurations = values;
                setZones(newZones);
              }}
              getOptionLabel={(option) => option.name}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox style={{ marginRight: 8 }} checked={selected} />
                  {option.name}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} variant="outlined" label={intl.formatMessage({ id: "alert.config" })} />
              )}
              required
            />
            <IconButton
              style={{ backgroundColor: palette.dividerLight }}
              onClick={() => {
                //Abrir el Modal para crear una configuración de alerta
                setOpenModal(true);
              }}
            >
              <AddIcon sx={{ color: palette.primary }} />
            </IconButton>
          </div>
        </FormControl>

        {openModal && <AlertConfig open={openModal} setOpen={setOpenModal} configData={configData} />}
      </div>
    </ThemeProvider>
  );
};

export default ThresholdsValues;
